export default {
  BASE_URL: '/sys/log',
  api: [
    {
      name: 'login',
      desc: '登录日志',
      method: 'GET',
      path: 'getLoginLog'
    },
    {
      name: 'operation',
      desc: '操作日志',
      method: 'GET',
      path: 'getOperateLog'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/system/log/index.js